import script from "./SuccesDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuccesDialog.vue?vue&type=script&lang=ts&setup=true"

import "./SuccesDialog.vue?vue&type=style&index=0&id=35a19267&lang=sass&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gyEBPJq1/0/curvesdev/skolkovo-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a19267"]])

export default __exports__